import React from 'react';
import UploadForm from '../../components/UploadForm';

const ReportsUpload: React.FC = () => {
  return <UploadForm />;
};

export default ReportsUpload; 